import {
	default as AkModal,
	type ModalDialogProps as AkModalDialogProps,
} from '@atlaskit/modal-dialog';

import { wrapComponentForChoreographer } from '../utils';

export const Modal = wrapComponentForChoreographer<AkModalDialogProps>(AkModal);
